import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/utils/api";
import { Mail, Smartphone, CalendarClock, ArrowRight, X } from "lucide-react";

// Sep 2026 — Ein Prüf-Banner für alle automatisch angelegten Belege:
// E-Mail-Eingang, Smartphone-Scans und Belege mit Datum außerhalb des laufenden Jahres.
export const InboundPendingBanner = ({ pending: pendingProp }) => {
  const navigate = useNavigate();
  const [pending, setPending] = useState(pendingProp || null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("inbound_banner_dismissed") === "1");

  useEffect(() => {
    if (pendingProp) { setPending(pendingProp); return; }
    api.get("/inbound/pending-count")
      .then((res) => setPending(res.data || null))
      .catch(() => {});
  }, [pendingProp]);

  const count = pending?.count || 0;
  if (dismissed || count === 0) return null;

  const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
  const rows = [];
  if (pending.email_count > 0) {
    rows.push({ icon: Mail, testId: "inbound-pending-row-email", text: <><strong>{plural(pending.email_count, "neuer Beleg", "neue Belege")} per E-Mail eingegangen</strong> — bitte prüfen und bestätigen.</> });
  }
  if (pending.scan_count > 0) {
    rows.push({ icon: Smartphone, testId: "inbound-pending-row-scan", text: <><strong>{plural(pending.scan_count, "Beleg", "Belege")} per Smartphone gescannt</strong> — KI-Werte bitte prüfen und bestätigen.</> });
  }
  if (pending.off_year_count > 0) {
    rows.push({ icon: CalendarClock, testId: "inbound-pending-row-offyear", text: <><strong>{plural(pending.off_year_count, "Beleg hat", "Belege haben")} ein Datum außerhalb {new Date().getFullYear()}</strong> — Belegdatum kontrollieren (Tippfehler der KI oder alter Beleg?).</> });
  }

  return (
    <div className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2.5" data-testid="inbound-pending-banner">
      <div className="flex-1 min-w-0 space-y-1">
        {rows.map((r) => (
          <p key={r.testId} className="flex items-start gap-2 text-sm text-amber-800" data-testid={r.testId}>
            <r.icon className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
            <span className="min-w-0">{r.text}</span>
          </p>
        ))}
      </div>
      <button
        onClick={() => navigate("/finances?filter=inbox")}
        className="inline-flex items-center gap-1 text-sm font-medium text-amber-700 hover:text-amber-900 shrink-0 mt-0.5"
        data-testid="inbound-pending-banner-link"
      >
        Belege prüfen <ArrowRight className="h-3.5 w-3.5" />
      </button>
      <button
        onClick={() => { sessionStorage.setItem("inbound_banner_dismissed", "1"); setDismissed(true); }}
        className="text-amber-400 hover:text-amber-600 shrink-0 mt-0.5"
        data-testid="inbound-pending-banner-dismiss"
        title="Ausblenden (bis zum nächsten Login)"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default InboundPendingBanner;
